import { Fragment } from "react";

const URL_RE = /(https?:\/\/[^\s)]+)/g;

export function linkify(text) {
  return text.split(URL_RE).map((part, i) =>
    URL_RE.test(part) ? (
      <a key={i} href={part} className="link break-all" target="_blank" rel="noopener noreferrer">{part}</a>
    ) : (
      <Fragment key={i}>{part}</Fragment>
    ),
  );
}

export const ContentBody = ({ body = "", className = "" }) => {
  const paragraphs = body.split(/\n\s*\n/).map((p) => p.trim()).filter(Boolean);
  return (
    <div className={`prose-care ${className}`}>
      {paragraphs.map((p, i) => {
        if (p.startsWith("## ")) {
          const [heading, ...rest] = p.split("\n");
          return (
            <Fragment key={i}>
              <h2>{heading.slice(3)}</h2>
              {rest.length > 0 && <p>{linkify(rest.join(" "))}</p>}
            </Fragment>
          );
        }
        if (p.split("\n").every((l) => l.startsWith("- "))) {
          return <ul key={i}>{p.split("\n").map((l, j) => <li key={j}>{linkify(l.slice(2))}</li>)}</ul>;
        }
        return <p key={i}>{linkify(p)}</p>;
      })}
    </div>
  );
};
